import React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { Link } from '@telia/styleguide';
import { AddressLookup, selectValidAddress } from '../../store/actions';
import { useStore } from '../../store/store';
import { pushPageview } from '../../util/GoogleTagManager';
import { routes } from '../../util/utils';
import { StreetNameSearch } from './AddressComponents';

const AddressSearch: React.FC<RouteComponentProps> = props => {
  const { dispatch } = useStore();

  const checkAvailability = (address: AddressLookup): void => {
    dispatch(selectValidAddress(address, false));
    pushPageview(routes.prices);
    props.history.push(routes.prices);
  };

  return (
    <Container>
      <StreetNameSearch checkAvailability={checkAvailability} />

      <Centered>
        <Link href="https://www.telia.no/internett/tradlost-bredband/#skjema" icon="arrow-right" iconPosition="after">
          Jeg finner ikke min adresse
        </Link>
      </Centered>
    </Container>
  );
};

export default AddressSearch;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Centered = styled('div')({
  marginTop: '2rem',
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
});
